import type { OrgUnitResources } from '../en/orgUnit';

export const orgUnit: OrgUnitResources = {
  title: 'Organisationseinheiten',
  loading: 'Organisationseinheiten werden geladen …',
  error: 'Organisationseinheiten konnten nicht geladen werden.',
  empty: 'Keine Organisationseinheiten.',
  companyFallback: 'Unternehmen',
  tabs: {
    chart: 'Diagramm',
    list: 'Liste',
  },
  columns: {
    name: 'Name',
    path: 'Pfad',
  },
  zoom: {
    out: 'Verkleinern',
    in: 'Vergrößern',
    reset: 'Zoom zurücksetzen',
  },
  chart: {
    noMembers: 'Niemandem zugewiesen',
  },
};
